const { NIMBUS_DATA_TYPES } = require('../nimbus-data-types');

module.exports = {
  displayName: 'Split Delivery',
  description: 'Optimize Split Delivery',
  sortOrder: 6,
  name: 'splitDelivery',
  documentKey: 'split_delivery',
  values: {
    splitDelivery: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'Do not split delivery',
      documentKey: 'donot_split_delivery',
    },
  },
};
